<template>
  <div id="v-collective-frame">
    <div class="collective-header" v-if="!loading">
      <h1 class="collective-header-heading" v-if="!message">
        <span>{{collectiveTitle}}</span>
      </h1>
      <h1 class="collective-header-heading" v-if="message"><span style="text-transform: uppercase; margin-top: 30vh; display: block;">An error occurred.</span></h1>
      <nav class="collective-header-nav" v-if="!message">
        <button>Follow ({{followers}})</button>
        <router-link to="./gallery">Gallery</router-link>
        <router-link to="./members">Members</router-link>
        <router-link to="./services">Services</router-link>
      </nav>
    </div>
    <transition name="slide-fade" mode="out-in">
      <router-view v-if="!loading && !message" :collective="currentCollective"></router-view>
      <div v-if="!loading && message" style="max-width: 500px; margin: 0 auto; line-height: 1.5">
        <p>{{message}}</p>
        <router-link to="/">Return to home.</router-link>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  name: 'CollectiveFrame',
  props: ['slug'],
  data: () => {
    return {
      loading: true,
      message: ''
    }
  },
  computed: {
    followers: function () {
      if (Object.keys(this.$store.state.collectives).indexOf('@' + this.slug) !== -1) {
        return Object.keys(this.$store.state.collectives['@' + this.slug].followers).length
      } else {
        return 0
      }
    },
    collectiveTitle: function () {
      if (Object.keys(this.$store.state.collectives).indexOf('@' + this.slug) !== -1) {
        return this.$store.state.collectives['@' + this.slug].fullname
      } else {
        return '@' + this.slug
      }
    },
    currentCollective: function () {
      return (this.$store.state.collectives['@' + this.slug] ? this.$store.state.collectives['@' + this.slug] : null)
    }
  },
  created: function () {
    this.$store.dispatch('fetchCollective', this.slug).then((data) => {
      if (data === false) {
        this.loading = false
        this.message = 'We could not find the collective you were searching for. It most likely was not created yet or was deleted by its creator.'
      } else {
        this.loading = false
      }
    }).catch(() => {
      this.loading = false
      this.message = 'We could not get the current collective. Try checking your internet connection.'
    })
  }
}
</script>
<style scoped>
.collective-header-nav router-link, .collective-header-nav a {
  display: inline-block;
  margin: 0 12px;
  vertical-align: middle;
}
.collective-header {
  margin-top: 60px;
  margin-bottom: 40px;
}
.collective-header-nav {
  margin-top: 30px;
}
</style>




// WEBPACK FOOTER //
// src/components/Collective/CollectiveFrame.vue